import { ADICIONAIS_BOOLEAN, ADICIONAIS_QUANTIDADE, PUXADOR_TIPOS } from '../data/adicionais'
import { CORES } from '../data/cores'
import { syncKey, safeSetItem } from './supabase'

const PRECOS_KEY = 'mini_tabela_precos'

export const PRECOS_DEFAULT = {
  modelos: {},
  multiplicadores: {},        // modelo → multiplicador individual
  multiplicadorDefault: 3.5,  // fallback global
  adicionais: Object.fromEntries([
    ...ADICIONAIS_BOOLEAN.map(a => [a.key, 0]),
    ...ADICIONAIS_QUANTIDADE.map(a => [a.key, 0]),
  ]),
  puxadores: Object.fromEntries(PUXADOR_TIPOS.map(t => [t, 0])),
  surchargeCores: { 'Sólidos': 0, 'Madeiras': 0, 'Lacas': 0 },
}

export function getPrecos() {
  try {
    const raw = localStorage.getItem(PRECOS_KEY)
    if (!raw) return structuredClone(PRECOS_DEFAULT)
    const saved = JSON.parse(raw)
    // merge para garantir que novas chaves apareçam
    return {
      modelos:             { ...PRECOS_DEFAULT.modelos,             ...saved.modelos },
      multiplicadores:     { ...PRECOS_DEFAULT.multiplicadores,     ...saved.multiplicadores },
      multiplicadorDefault: saved.multiplicadorDefault ?? PRECOS_DEFAULT.multiplicadorDefault,
      adicionais:          { ...PRECOS_DEFAULT.adicionais,          ...saved.adicionais },
      puxadores:           { ...PRECOS_DEFAULT.puxadores,           ...saved.puxadores },
      surchargeCores:      { ...PRECOS_DEFAULT.surchargeCores,      ...saved.surchargeCores },
    }
  } catch { return structuredClone(PRECOS_DEFAULT) }
}

export function savePrecos(precos) {
  // safeSetItem — se o quota estoura silenciosamente aqui, o syncKey
  // abaixo leria o raw ANTIGO e empurraria o antigo pro Supabase, criando
  // o bug "muda e volta ao atualizar". safeSetItem libera cache do Bling
  // antes de desistir.
  safeSetItem(PRECOS_KEY, JSON.stringify(precos))
  syncKey(PRECOS_KEY)
}

// ── Motor de cálculo ──────────────────────────────────────────────────────────

export function calcularPreco(config) {
  const precos = getPrecos()
  const itens  = []

  // Base do modelo
  const base = Number(precos.modelos[config.modelo] || 0)
  if (config.modelo) {
    itens.push({ label: config.modelo, valor: base, tipo: 'base' })
  }

  // Surcharge de cor
  const cor = CORES.find(c => c.nome === config.cor)
  if (cor && base > 0) {
    const pct = Number(precos.surchargeCores[cor.tipo] || 0)
    if (pct !== 0) {
      const surcharge = Math.round(base * pct) / 100
      itens.push({ label: `Cor ${cor.tipo} (+${pct}%)`, valor: surcharge, tipo: 'surcharge' })
    }
  }

  // Puxador
  const ads = config.adicionais || {}
  if (ads.puxadorTipo) {
    const precoPux = Number(precos.puxadores[ads.puxadorTipo] || 0)
    const qtd      = Number(ads.puxadorQtd) || 1
    const cor2     = ads.puxadorCor ? ` ${ads.puxadorCor}` : ''
    const label    = `Puxador ${ads.puxadorTipo}${cor2} × ${qtd}`
    itens.push({ label, valor: precoPux * qtd, tipo: 'adicional' })
  }

  // Adicionais booleanos
  ADICIONAIS_BOOLEAN.forEach(({ key, label }) => {
    if (ads[key]) {
      itens.push({ label, valor: Number(precos.adicionais[key] || 0), tipo: 'adicional' })
    }
  })

  // Adicionais com quantidade
  ADICIONAIS_QUANTIDADE.forEach(({ key, label }) => {
    const qtd = Number(ads[key] || 0)
    if (qtd > 0) {
      itens.push({ label: `${label} × ${qtd}`, valor: Number(precos.adicionais[key] || 0) * qtd, tipo: 'adicional' })
    }
  })

  const total = itens.reduce((s, i) => s + i.valor, 0)
  const semPreco = itens.some(i => i.valor === 0 && i.tipo !== 'surcharge')

  return { itens, total, semPreco }
}
